export const CabinetIcon = ({ ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M345 5095 l-25 -24 0 -905 c0 -497 3 -912 6 -921 18 -45 20 -45 794
-45 537 0 737 3 753 12 46 24 46 28 47 336 l0 292 640 0 640 0 0 -294 c0 -274
1 -295 19 -317 l19 -24 744 -3 c525 -2 751 1 770 9 14 6 31 23 37 37 8 19 11
289 9 930 l-3 904 -24 19 c-23 19 -72 19 -2213 19 l-2189 0 -24 -25z m1415
-935 l0 -800 -640 0 -640 0 0 800 0 800 640 0 640 0 0 -800z m1440 320 l0
-480 -640 0 -640 0 0 480 0 480 640 0 640 0 0 -480z m1440 -320 l0 -800 -640
0 -640 0 0 800 0 800 640 0 640 0 0 -800z"
      />
      <path
        d="M585 4295 c-24 -23 -25 -31 -25 -135 0 -104 1 -112 25 -135 15 -16
36 -25 55 -25 19 0 40 9 55 25 24 23 25 31 25 135 0 104 -1 112 -25 135 -15
16 -36 25 -55 25 -19 0 -40 -9 -55 -25z"
      />
      <path
        d="M2425 4215 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 22 -23 31
-25 124 -25 110 0 143 10 160 47 17 37 13 62 -14 88 -23 24 -31 25 -135 25
-104 0 -112 -1 -135 -25z"
      />
      <path
        d="M3465 4295 c-24 -23 -25 -31 -25 -135 0 -104 1 -112 25 -135 15 -16
36 -25 55 -25 19 0 40 9 55 25 24 23 25 31 25 135 0 104 -1 112 -25 135 -15
16 -36 25 -55 25 -19 0 -40 -9 -55 -25z"
      />
      <path
        d="M3945 2615 c-25 -24 -25 -24 -25 -240 l0 -215 -77 0 c-78 0 -78 0
-93 33 -18 38 -58 55 -97 41 -16 -5 -34 -23 -43 -41 l-15 -33 -93 0 c-85 0
-95 -2 -117 -25 -23 -22 -25 -32 -25 -120 l0 -95 -1495 0 -1496 0 -24 -25 -25
-24 0 -911 0 -911 25 -24 24 -25 2189 0 c2141 0 2190 0 2213 19 l24 19 3 899
c1 494 0 908 -3 921 -11 43 -40 62 -100 62 l-55 0 0 95 c0 88 -2 98 -25 120
-22 23 -32 25 -117 25 l-93 0 -15 33 c-9 18 -27 36 -42 41 -40 14 -80 -3 -98
-41 -15 -33 -15 -33 -92 -33 l-77 0 -3 221 c-3 218 -3 221 -27 240 -32 26 -77
24 -106 -6z m535 -655 l0 -40 -480 0 -480 0 0 40 0 40 480 0 480 0 0 -40z
m-2720 -560 l0 -360 -640 0 -640 0 0 360 0 360 640 0 640 0 0 -360z m720 -440
l0 -800 -280 0 -280 0 0 800 0 800 280 0 280 0 0 -800z m720 0 l0 -800 -280 0
-280 0 0 800 0 800 280 0 280 0 0 -800z m1440 0 l0 -800 -640 0 -640 0 0 800
0 800 640 0 640 0 0 -800z m-2880 -440 l0 -360 -640 0 -640 0 0 360 0 360 640
0 640 0 0 -360z"
      />
      <path
        d="M985 1655 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 22 -23 31
-25 124 -25 110 0 143 10 160 47 17 37 13 62 -14 88 -23 24 -31 25 -135 25
-104 0 -112 -1 -135 -25z"
      />
      <path
        d="M2265 1095 c-24 -23 -25 -31 -25 -135 0 -104 1 -112 25 -135 32 -33
78 -33 111 0 25 25 26 29 22 141 -3 108 -5 117 -27 135 -32 26 -77 24 -106 -6z"
      />
      <path
        d="M2745 1095 c-24 -23 -25 -31 -25 -135 0 -104 1 -112 25 -135 32 -33
78 -33 111 0 25 25 26 29 22 141 -3 108 -5 117 -27 135 -32 26 -77 24 -106 -6z"
      />
      <path
        d="M3465 1095 c-24 -23 -25 -31 -25 -135 0 -104 1 -112 25 -135 32 -33
78 -33 111 0 25 25 26 29 22 141 -3 108 -5 117 -27 135 -32 26 -77 24 -106 -6z"
      />
      <path
        d="M985 775 c-16 -15 -25 -36 -25 -55 0 -19 9 -40 25 -55 23 -24 31 -25
133 -25 126 0 149 10 158 72 5 30 2 41 -19 62 -25 25 -31 26 -137 26 -104 0
-112 -1 -135 -25z"
      />
    </g>
  </svg>
);
